import React, { useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";

const SentPrice = ({ fileId, price, setRefreshData }) => {
  const [newPrice, setNewPrice] = useState(price);
  const [feasible, setFeasible] = useState("POSSIBLE");
  const [notes, setNotes] = useState("");
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attachment, setAttachment] = useState(null);

  const handleFileChange = (e) => {
    setAttachment(e.target.files[0]);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const jsonData = {
        price: newPrice,
        feasible,
        notes,
      };

      const formData = new FormData();
      if (!attachment && feasible === "POSSIBLE") {
        alert("Attachment of the mod file is missing!");
        return;
      }
      formData.append("file", attachment);
      formData.append("jsonData", JSON.stringify(jsonData));

      await axiosInstance.put(`/files/${fileId}/feasible-and-price`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setRefreshData(true);
      setModal(false);
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-6">
      <div>
        <button
          onClick={() => setModal(true)}
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M3 4a2 2 0 012-2h10a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V4zm5 4a1 1 0 000 2h4a1 1 0 000-2H8z"
              clipRule="evenodd"
            />
          </svg>
          Possible & Price
        </button>
      </div>

      {modal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-xl font-semibold text-center mb-4">
              Update Details
            </h2>

            <div className="mb-4">
              <label className="block text-sm font-medium">Feasible</label>
              <select
                value={feasible}
                onChange={(e) => setFeasible(e.target.value)}
                className="w-full mt-1 p-2 border rounded-md"
              >
                <option value="POSSIBLE">POSSIBLE</option>
                <option value="NOT_POSSIBLE">NOT POSSIBLE</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium">Paid Price</label>
              <input
                type="number"
                value={newPrice}
                onChange={(e) => setNewPrice(Number(e.target.value))}
                className="w-full mt-1 p-2 border rounded-md"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium">Notes</label>
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                className="w-full mt-1 p-2 border rounded-md"
                rows="3"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium">Attachment</label>
              <input
                type="file"
                onChange={handleFileChange}
                className="w-full mt-1"
                required
              />
            </div>

            <div className="flex justify-end space-x-2">
              <button
                onClick={() => setModal(false)}
                className="px-4 py-2 bg-gray-500 text-white rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-blue-600 text-white rounded"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SentPrice;
